import { render } from "./BuyNewBenefito10PrepaidCard.vue?vue&type=template&id=308973b3&scoped=true"
import script from "./BuyNewBenefito10PrepaidCard.vue?vue&type=script&lang=js"
export * from "./BuyNewBenefito10PrepaidCard.vue?vue&type=script&lang=js"

import "./BuyNewBenefito10PrepaidCard.vue?vue&type=style&index=0&id=308973b3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-308973b3"]])

export default __exports__